module.exports = __webpack_public_path__ + "img/greenpig.393c5efa.png";